import React from 'react';
import { connect } from 'react-redux';
import { TWServiceProfileLayout } from '.';
import TWTopNavProfile from '../TWTopNav/TWTopNav.profile.container';
import TWMobileNavProfileContainer from '../TWMobileNav/TWMobileNav.profile.container';
import { jsx as _jsx } from "react/jsx-runtime";

var TWServiceProfileLayoutContainer = function TWServiceProfileLayoutContainer(_ref) {
  var children = _ref.children,
      classes = _ref.classes,
      userIsLoggedIn = _ref.userIsLoggedIn;
  return /*#__PURE__*/_jsx(TWServiceProfileLayout, {
    headerSlot: userIsLoggedIn && /*#__PURE__*/_jsx(TWTopNavProfile, {}),
    sidebarSlot: userIsLoggedIn && /*#__PURE__*/_jsx(TWMobileNavProfileContainer, {}),
    classes: classes,
    children: children
  });
};

var mapStateToProps = function mapStateToProps(state) {
  var _state$auth$users$cur;

  return {
    userIsLoggedIn: !!((_state$auth$users$cur = state.auth.users.current) !== null && _state$auth$users$cur !== void 0 && _state$auth$users$cur.id)
  };
};

var mapDispatchToProps = function mapDispatchToProps() {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(TWServiceProfileLayoutContainer);